export const SELECTED_PERIODS_LOCAL_KEY = "SELECTED_GRADING_PERIODS"
export const CORE_IDEA_VIEW_OPEN_KEY = "CORE_IDEA_VIEW_MODAL" // key to automatically open the View Core Ideas Modal on Teacher Sci 35 assignments page
